import DoneIcon from '@mui/icons-material/Done';
import React from "react";
import approvedImage from "../../assets/svg/approved.svg";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CustomButton from "../../component/elements/CustomButton/CustomButton"; // adjust import if needed

const Unauthorized = () => {
  const navigate = useNavigate();
  const { approvalDetails } = useSelector((state) => state.counter);
  const { name = "" } = approvalDetails || {};

  const handleBackHome = () => {
    navigate('/'); 
  };

  return (
    <div className='h-[calc(100vh-80px)] flex items-center justify-center'>
      <div className="h-[calc(100vh-150px)] flex items-end justify-center bg-[#4293C6] rounded-[30px] mx-1 p-2 sm:mx-10 sm:px-16 sm:pt-16 xs:pb-3 ">
        <div className="bg-[#F9FDFF] rounded-[30px] shadow-lg h-full p-10 w-full flex flex-col sm:flex-row items-center justify-center gap-8">

          {/* Left Section */}
          <div className='w-full xl:w-[40%] flex flex-col items-start'>
            <h2 className="text-2xl font-semibold text-[#222] mb-2">
              Dear {name || "User"},
            </h2>
            <p className="text-[#222] mb-2">Thank you for registering!</p>
            <p className="text-[#222] mb-6">
              You are not authorized to access the platform. Please contact your administrator to request the necessary permissions.
            </p>

            <CustomButton
              customeClass="gradient-button w-[180px] h-[40px]"
              onClick={handleBackHome}
            >
              Back to Home
            </CustomButton>
          </div>

          <div className='hidden lg:flex'>
            <img
              src={approvedImage}
              alt="Approval Illustration"
              className="w-full max-w-[600px] mx-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
